import {
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Divider,
  Link,
} from "@material-ui/core";
import { Close, People } from "@material-ui/icons";
import { Atendimento } from "../../../../interfaces/atendimento";
import { cpfMask } from "../../../../utils/cpfFormat";
import { dateFormat } from "../../../../utils/dateFormat";

import useStyles from "./style";

interface Props {
  openDependentsDialog: boolean;
  setOpenDependentsDialog: (openDependentsDialog: boolean) => void;
  attendance: undefined | Atendimento;
}

export default function DependentsDialog({
  setOpenDependentsDialog,
  openDependentsDialog,
  attendance,
}: Props): JSX.Element {
  const classes = useStyles();

  const handleClose = () => {
    setOpenDependentsDialog(false);
  };

  return (
    <Dialog
      fullWidth
      open={openDependentsDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton onClick={handleClose} className={classes.buttonClose}>
        <Close />
      </IconButton>
      <DialogTitle className={classes.header}>
        <Typography className={classes.textHeaderModal}>DEPENDENTE</Typography>
      </DialogTitle>
      {attendance && attendance.para_dependente && attendance.dependentes && (
        <DialogContent>
          <People color="primary" fontSize="large" />
          <Box className={classes.titleDependents}>
            <Typography className={classes.textModalTitleUDependent}>
              {attendance.dependentes.nome}
            </Typography>
            <Typography className={classes.textModalTitleUDependentCPF}>
              {cpfMask(attendance.dependentes.cpf)}
            </Typography>
          </Box>
          <Box mb={3}>
            <Typography className={classes.textModalTitle}>
              Data de nascimento
            </Typography>
            <Typography className={classes.textModal}>
              {`${dateFormat(attendance.dependentes.data_nascimento)}`}
            </Typography>
          </Box>
          <Box mb={3}>
            <Typography className={classes.textModalTitle}>
              grau de parentesco
            </Typography>
            <Typography className={classes.textModal}>
              {attendance.dependentes.grau_parentesco}
            </Typography>
          </Box>
          <Divider light />
          <div className={classes.buttonCloseModal}>
            <Link className={classes.link} onClick={handleClose}>
              fechar
            </Link>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
}
